import copy from 'fast-copy';
import { toast } from 'react-toastify';
import isEqual from 'react-fast-compare';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2'

import Print from './Print';
import Export from './Export';
import Deployment from './Deployment';
import DeploymentDetails from './DeploymentDetails';
import HistoryDetails from '../Reporting/HistoryDetails';

import { colors, roles, toastTimerValue } from '../../../Shared/utils';
import { useAppContext } from '../../../Context/App/Provider';
import { getRealtimeDeployments } from '../../../Functions/reporting';
import { useRealtimeContext } from '../../../Context/Realtime/Provider';
import { getSelectedLocations, multiSelectStrings, decodeHTMLEntities } from '../../../Functions/utils';

import { updateSavedGroups, updateSavedLocations } from '../../../Functions/user';

import GroupSelect from "./GroupSelect";
import LocationSelect from './LocationSelect';

import './Realtime.css';
import '../../SweetAlert.css'


const showDeployments = async (t, setDeployments, pickers, selected, locations = null) => {
  setDeployments({ active: null, done: null, loading: true });

  if (!locations)
    locations = getSelectedLocations(pickers.locations.show, selected.locations);

  if (locations.length === 0)
    return setDeployments({ active: null, done: null, loading: false });

  const res = await getRealtimeDeployments(locations);
  // console.log("42 - res=", res);
  const deployments = res.success ? res.deployments : { active: [], done: [], loading: false };

  if (!res.success) {
    toast(decodeHTMLEntities(t('realtime.error')), { type: 'error' });

    // Swal.fire({
    //   toast: true,
    //   icon: 'error',
    //   title: t('realtime.error'),
    //   animation: true,
    //   position: 'top-right',
    //   showConfirmButton: false,
    //   timer: toastTimerValue,
    //   timerProgressBar: true,
    //   iconColor: 'white',
    //   customClass: {
    //     popup: 'colored-toast',
    //   },
    //   didOpen: (toast) => {
    //     toast.addEventListener('mouseenter', Swal.stopTimer)
    //     toast.addEventListener('mouseleave', Swal.resumeTimer)
    //     toast.addEventListener('click', Swal.close)
    //   }
    // });
  }

  setDeployments(deployments);
  // Keep deployments loaded locally temporarily
  sessionStorage.setItem('realtimeData', JSON.stringify(deployments));
};

const selectedDeployment = (deployment, setDeployment) => {
  // console.log("74 - deployment=", deployment);

  //return deployment ? <DeploymentDetails deployment={deployment} setDeployment={setDeployment} /> : null
  return (deployment ? <HistoryDetails deployment={deployment} setDeployment={setDeployment} /> : null)
};


export default function Realtime() {
  const { t } = useTranslation();
  const [{ user }] = useAppContext();
  const [{ choice, pickers, selected }, dispatch] = useRealtimeContext();

  const [deployment, setDeployment] = useState(null);
  const [prevLocs, setPrevLocs] = useState(selected.locations);
  const [deployments, setDeployments] = useState({ active: null, done: null, loading: false });

  // Keep deployments between page refreshes in session storage
  const rtData = useRef(sessionStorage.getItem('realtimeData'));

  // auto-loads deployments if user has location(s) already set
  const [load, setLoad] = useState(selected.locations.length > 0);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);


  const handleLoadDeployments = useCallback((data = null) => {
    if (data || load || !isEqual(prevLocs, selected.locations)) {
      setPrevLocs(data?.selected?.locations ?? selected.locations);
      showDeployments(t, setDeployments, data?.pickers ?? pickers, data?.selected ?? selected);
    }
  }, [load, pickers, prevLocs, selected, setDeployments, t]);

  // const handleChangeGroups = (groups) => {
  //   dispatch({
  //     pickers: {
  //       ...pickers,
  //       locations: {
  //         all: pickers.locations.all,
  //         show: groups.length === 0 ? [] : pickers.locations.all.filter(loc => {
  //           const array = [];
  //           groups.forEach(group => array.push(group.value));
  //           // Show non-indented group name if multiple groups are selected
  //           return array.includes(loc.group ?? (groups.length === 1 ? null : loc.value));
  //         })
  //       }
  //     }
  //   });

  //   // if user unselects all groups (manually or with the x icon)
  //   if (groups.length === 0) {
  //     handleChangeLocations([]);
  //     return dispatch({ selected: { groups: [], locations: [] } });
  //   }

  //   // remove selected locations from unselected groups
  //   const groupIds = [], newLocations = [];
  //   groups.sort((a, b) => a.sort - b.sort).forEach(group => groupIds.push(group.value));

  //   pickers.locations.show.forEach(loc => {
  //     // if loc.group is undefined, it's for selecting the entire group so the group is loc.value
  //     if (groupIds.includes(loc.group ?? loc.value) && selected.locations.some(l => l.value === loc.value)) {
  //       newLocations.push(loc);
  //     }
  //   });

  //   dispatch({ selected: { groups, locations: groups.length > 0 ? newLocations : [] } });
  // };

  const handleChangeGroups = (selectedGroups, newGroups) => {
    handleSetGroups(true, newGroups);
  };


  const handleSetGroups = (force = false, newGroups = []) => {

    // console.log("145 - handleSetGroups=", force);
    // console.log("146 - selected.groups=", selected.groups);
    // console.log("147 - selectedGroups=", selectedGroups);
    // console.log("148 - newGroups=", newGroups);

    // console.log("149 - isEqual(selected.groups, selectedGroups)=", isEqual(selected.groups, selectedGroups));

    if (
      !isEqual(selected.groups, selectedGroups) ||
      force

    ) {
      // const groups = (!force) ? copy(selectedGroups) : copy([]);
      const groups = copy(selectedGroups);

      const groupList = [];
      for (const group of groups) {
        groupList.push(group.value);
        }
      updateSavedGroups(JSON.stringify(groupList));

      const newGroupList = [];
      for (const group of newGroups) {
        newGroupList.push(group.value);
      }

    // if user unselects all groups (manually or with the x icon)
    if (groups.length === 0) {
        handleSetLocations([]);
      return dispatch({ selected: { groups: [], locations: [] } });
    }

    // remove selected locations from unselected groups
    const groupIds = [], newLocations = [];
    groups.sort((a, b) => a.sort - b.sort).forEach(group => groupIds.push(group.value));

    pickers.locations.show.forEach(loc => {
      // if loc.group is undefined, it's for selecting the entire group so the group is loc.value
      if (groupIds.includes(loc.group ?? loc.value) && selected.locations.some(l => l.value === loc.value)) {
        newLocations.push(loc);
      }
    });


      pickers.locations.all.filter(loc => {
        const array = [];
        groups.forEach(group => array.push(group.value));

        // Show non-indented group name if multiple groups are selected              
        return array.includes(loc.group ?? (groups.length === 1 ? null : loc.value));
      }).forEach(loc => {
        if (newGroupList.includes(loc.group)) {
          newLocations.push(loc);
        }
      });

      // console.log("selected.locations=", selected.locations);
      // console.log("newLocations=", newLocations);
      const locationList = [];
      for (const location of newLocations) {
        locationList.push(location.value);
      }
      updateSavedLocations(JSON.stringify(locationList));


      dispatch({
        pickers: {
          ...pickers,
          locations: {
            all: pickers.locations.all,
            show: groups.length === 0 ? [] : pickers.locations.all.filter(loc => {
              const array = [];
              groups.forEach(group => array.push(group.value));

              // Show non-indented group name if multiple groups are selected              
              return array.includes(loc.group ?? (groups.length === 1 ? null : loc.value));
            })
          }
        },
        selected: {
          locations: newLocations,
          groups
        }
      });
      setLoad(true);
    }
  };

  // const handleChangeLocations = (locations) => {
  //   dispatch({
  //     selected: {
  //       ...selected,
  //       // Sort selected locations in the pickers order
  //       locations: locations.sort((a, b) => a.sort - b.sort)
  //     }
  //   });

  //   if (locations.length === 0) {
  //     setPrevLocs([]);
  //     return showDeployments(t, setDeployments, pickers, selected, []);
  //   }
  // };

  const handleChangeLocations = (locations) => {
    handleSetLocations(true);
  };

  const handleSetLocations = (force = false) => {
    if (
      !isEqual(selected.locations, selectedLocations) ||
      force
    ) {
      // const locations = (!force) ? copy(selectedLocations) : copy([]);
      const locations = copy(selectedLocations);
      const filteredLocations = [];

      const locationList = [];
      for (const location of locations) {
        if (location.group) {
          filteredLocations.push(location);
          locationList.push(location.value);
        }
      }
      updateSavedLocations(JSON.stringify(locationList));

    dispatch({
      selected: {
        ...selected,
        // Sort selected locations in the pickers order
          locations: filteredLocations.sort((a, b) => a.sort - b.sort)
      }
    });

      if (filteredLocations.length === 0) {
      setPrevLocs([]);
      return showDeployments(t, setDeployments, pickers, selected, []);
    }
      //handleLoadDeployments();
      setLoad(true);
    }
  };


  const getDeploymentsTitle = () => {
    if (!deployments[choice]) return null;

    if (deployments[choice].length === 0) {
      return (<h1 style={{ color: colors.softthinks }}>{t('realtime.total')} 0</h1>);
    }

    if (deployments[choice].filter(dep => dep.error_module_result_data).length > 0) {
      return (<h1 style={{ color: colors.error }}>
        {t('realtime.' + choice + '.error')} {deployments[choice].filter(dep => dep.error_module_end_date).length}
      </h1>);
    } else {
      return (<h1 style={{ color: colors.success }}>
        {t('realtime.' + choice + '.success')} {deployments[choice].filter(dep => !dep.error_module_end_date).length}
      </h1>);
    }
  };


  useEffect(() => {
    document.title = t('realtime.page');

    if (load) {
      if (rtData.current !== null) {
        // Should only work once when loading the realtime page
        setDeployments(JSON.parse(rtData.current));
        rtData.current = null;
      } else {
        handleLoadDeployments();
      }
      setLoad(false);
    }
    
    setSelectedGroups(selected.groups);
    setSelectedLocations(selected.locations);

  }, [t, load, rtData, handleLoadDeployments, setSelectedGroups, setSelectedLocations]);


  //  console.log("333 - deployments=", deployments);


  // console.log("302 - selected=", selected);
  if (deployment !== null) {
    return (
      <HistoryDetails deployment={deployment} setDeployment={setDeployment} />
    )
  }

  return (
    <div className="realtime">
      <div className="MuiDataGrid-root MuiDataGrid-root" role="grid" aria-colcount={0} aria-rowcount={0}>
        <div>
          <div className="content__header">
            {!deployments[choice] && !deployments.loading ? <h2>{t('realtime.choose')}</h2> : (
              <h2>
                {t('realtime.title.' + choice) + '\u2000\u2013\u2000'}
                <span style={{ color: colors.softthinks }}>
                  {deployments[choice] ? deployments[choice].length : t('global.loading') + '...'}
                </span>
              </h2>
            )}

            <div className="options">
              {deployments[choice] && <>
                <div className="actions">
                  <button title={t('global.refresh')} className="button icon" onClick={() => setLoad(true)}>
                    <span className="material-icons-round">cached</span> {/* Refresh deployments */}
                  </button>

                  {deployments[choice].length > 0 && <>
                    <Export type={choice} /> {/* Excel / PDF Download */}

                    <button title={t('global.actions.print')} className="button icon" onClick={window.print}>
                      <span className="material-icons-round">print</span> {/* Print */}
                    </button>
                  </>}
                </div>

                <span className="separation" />
              </>}

              <Button
                onClick={() => dispatch({ choice: 'active' })}
                className={'button' + (choice === 'active' ? ' selected' : '')}
              >
                {t('realtime.buttons.active')}
              </Button>
              <Button
                onClick={() => dispatch({ choice: 'done' })}
                className={'button' + (choice === 'done' ? ' selected' : '')}
              >
                {t('realtime.buttons.done')}
              </Button>
            </div>
          </div>
        </div>

        <div className="MuiDataGrid-main">
          <div className="MuiDataGrid-header">
            <div className="pickers">
              {/* {user.roleId === roles.stAdmin && (
                <div className="sidebar__select">
                  <p className="sidebar__label">{t('sidebar.filters.groups')}</p>
                  <MultiSelect
                    value={selected.groups}
                    options={pickers.groups}
                    overrideStrings={multiSelectStrings(t, 'grp')}
                    onChange={groups => handleChangeGroups(groups)} // Show relevant locations on group select
                    onMenuToggle={visible => !visible && handleLoadDeployments()} // Refresh locations if needed
                    ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
                    valueRenderer={(items) => {
                      const values = items.map(loc => loc.label).join(', ');
                      return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t, 'grp').selectSomeItems;
                    }}
                  />
                </div>
              )} */}

              {user.roleId <= roles.stAdmin && (
                <div className="sidebar__select">
                  <p className="sidebar__label">{t('sidebar.filters.groups')}</p>
                  <GroupSelect
                    onChangeGroups={handleChangeGroups}
                  />
                </div>
              )}

              {/* {(pickers.locations.show.length > 1 || user.roleId !== roles.user) && (
                <div className={'sidebar__select' + (selected.groups.length > 0 ? '' : ' disabled')}>
                  <p className="sidebar__label">{t('sidebar.filters.locations')}</p>
                  <MultiSelect
                    value={selected.locations}
                    options={pickers.locations.show}
                    disabled={selected.groups.length === 0} // no group
                    overrideStrings={multiSelectStrings(t, 'loc', selected)}
                    onChange={locations => handleChangeLocations(locations)}
                    onMenuToggle={visible => !visible && handleLoadDeployments()}
                    ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
                    valueRenderer={(items) => {
                      const values = items.map(loc => loc.label.replace('\u2001', '')).join(', ');
                      return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t, 'loc', selected).selectSomeItems;
                    }}
                  />
                </div>
              )} */}

              {(pickers.locations.show.length > 1 || user.roleId !== roles.user) && (
                <div className={'sidebar__select' + (selected.groups.length > 0 ? '' : ' disabled')} disabled>
                  <p className="sidebar__label">{t('sidebar.filters.locations')}</p>
                  <LocationSelect
                    onChangeLocations={handleChangeLocations}
                  />
                </div>
              )}
            </div>

            {getDeploymentsTitle(deployments[choice])}
          </div>

          <div className="MuiDataGrid-content">
            {deployments[choice] ? ( // deployments are loaded
              deployments[choice].length > 0 ? ( // there are deployments to show
                <>
                  {deployments[choice].filter(dep => dep.error_module_result_data).length > 0 ? <>
                    <span className="realtime__row">
                      {deployments[choice].filter(dep => dep.error_module_result_data).map(dep => (
                        <span
                          onClick={
                            (e) => {
                              if (e && e.detail === 2) {
                                setDeployment(dep);
                              }
                            }
                          }>
                          <Deployment
                            id="deploymentCard"
                            key={dep.deployment_id}
                            dep={dep}
                            setDeployment={setDeployment}
                          />
                        </span>
                      ))}
                    </span>

                    <h1 style={{ color: colors.success }}>
                      {t('realtime.' + choice + '.success')} {deployments[choice].filter(dep => !dep.error_module_result_data).length}
                    </h1>
                  </> : null}

                  <div
                    className="realtime__row"
                    style={{ paddingBottom: deployments[choice].filter(dep => !dep.error_module_result_data).length > 0 ? '30px' : 0 }}
                  >
                    {deployments[choice].filter(dep => !dep.error_module_result_data).map(dep => (
                      <span
                        onClick={
                          (e) => {
                            if (e && e.detail === 2) {
                              setDeployment(dep);
                            }
                          }
                        }>
                        <Deployment
                          key={dep.deployment_id}
                          dep={dep}
                          setDeployment={setDeployment}
                        />
                      </span>
                    ))}
                  </div>
                </>
              ) : ( // there are no deployments to show
                <div className="loader">
                  <h2>{t('realtime.no_' + choice)}</h2>
                </div>
              )
            ) : (
              deployments.loading ? ( // deployments are not loaded or loading
                <div className="loader">
                  <BeatLoader color={colors.softthinks} />
                </div>
              ) : null
            )}
          </div>
        </div>
      </div>
      {deployments[choice]?.length > 0 && <Print choice={choice} deployments={deployments} selected={selected} />}
      {selectedDeployment(deployment, setDeployment)}

      {deployment !== null && <HistoryDetails deployment={deployment} setDeployment={setDeployment} />}
    </div>

  );
}
